import React from 'react';

const AccessContext = React.createContext()

export default AccessContext;
